const e=async(e,t)=>{let{data:n}=await e.get(`/roles/${t}`);return n};export{e as getRole};
//# sourceMappingURL=get-role.mjs.map